/* Facets: Section Rendering API with no-JS GET fallback, stale-request protection and Theme Editor-safe lifecycle. */
(function () {
  'use strict';
  if (customElements.get('bb-facets')) return;

  class BBFacets extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle) this.lifecycle.abort();
      this.lifecycle = new AbortController();
      const signal = this.lifecycle.signal;

      this.form = this.querySelector('form');
      this.sectionId = this.getAttribute('data-section');
      this.target = document.querySelector('#collection-grid-' + this.sectionId);
      this.request = null;

      if (!this.form || !this.target) return;

      this.form.addEventListener('change', (e) => {
        if (e.target.matches('[data-facets-sort-mobile]')) {
          const sort = this.form.querySelector('[data-facets-sort]');
          if (sort) sort.value = e.target.value;
        }
        if (e.target.matches('input[type="number"]')) return;
        if (window.innerWidth >= 1024 || e.target.matches('[data-facets-sort], [data-facets-sort-mobile]')) this.apply();
      }, { signal });

      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.apply();
      }, { signal });

      document.addEventListener('click', (e) => {
        const link = e.target.closest('[data-facets-remove], [data-facets-clear]');
        if (link && this.contains(link)) {
          e.preventDefault();
          this.load(link.href);
        }
      }, { signal });

      window.addEventListener('popstate', () => this.load(location.href, true), { signal });
    }

    disconnectedCallback() {
      if (this.lifecycle) this.lifecycle.abort();
      this.lifecycle = null;
      if (this.request) this.request.abort();
      this.request = null;
    }

    apply() {
      const params = new URLSearchParams(new FormData(this.form));
      Array.from(params.keys()).forEach((key) => {
        if (params.get(key) === '') params.delete(key);
      });
      this.load(this.form.action.split('?')[0] + '?' + params.toString());
    }

    load(url, noPush) {
      if (!this.target) return;
      if (this.request) this.request.abort();
      this.request = new AbortController();
      const signal = this.request.signal;

      this.target.setAttribute('aria-busy', 'true');
      const requestUrl = new URL(url, location.origin);
      requestUrl.searchParams.set('section_id', this.sectionId);

      fetch(requestUrl.toString(), { signal, headers: { Accept: 'text/html' } })
        .then((response) => {
          if (!response.ok) throw new Error('Facets request failed: ' + response.status);
          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = doc.querySelector('#collection-grid-' + this.sectionId);
          const facets = doc.querySelector('bb-facets');

          if (!grid || !facets) throw new Error('Facets response incomplete');

          this.target.innerHTML = grid.innerHTML;

          // Collection promotions are outside the grid, so refresh them with
          // the same section response to keep offers aligned with active filters.
          const currentSection = document.getElementById('collection-' + this.sectionId);
          const returnedSection = doc.getElementById('collection-' + this.sectionId);
          if (currentSection && returnedSection) {
            const currentPromo = currentSection.querySelector('.bb-collection__promo');
            const returnedPromo = returnedSection.querySelector('.bb-collection__promo');
            if (currentPromo && returnedPromo) currentPromo.replaceWith(returnedPromo);
            else if (currentPromo) currentPromo.remove();
            else if (returnedPromo) {
              const body = currentSection.querySelector('.bb-collection__body');
              if (body) body.before(returnedPromo);
            }
          }

          const active = facets.querySelector('.bb-facets__active');
          const mine = this.querySelector('.bb-facets__active');
          if (mine) mine.remove();
          if (active) this.form.appendChild(active);

          const count = facets.querySelector('[data-facets-count]');
          const myCount = this.querySelector('[data-facets-count]');
          if (count && myCount) myCount.innerHTML = count.innerHTML;

          const drawerBody = facets.querySelector('.bb-facets__drawer .bb-drawer__body .bb-accordion');
          const myBody = this.querySelector('.bb-facets__drawer .bb-drawer__body .bb-accordion');
          if (drawerBody && myBody) myBody.innerHTML = drawerBody.innerHTML;

          const sourceSort = facets.querySelector('[data-facets-sort]');
          const mySort = this.querySelector('[data-facets-sort]');
          if (sourceSort && mySort) mySort.value = sourceSort.value;

          const sourceMobileSort = facets.querySelector('[data-facets-sort-mobile]');
          const myMobileSort = this.querySelector('[data-facets-sort-mobile]');
          if (sourceMobileSort && myMobileSort) myMobileSort.value = sourceMobileSort.value;

          if (!noPush) {
            const clean = new URL(url, location.origin);
            clean.searchParams.delete('section_id');
            history.pushState({}, '', clean.toString());
          }

          this.target.setAttribute('aria-busy', 'false');
          document.dispatchEvent(new CustomEvent('bb:facets:updated'));
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          this.target.setAttribute('aria-busy', 'false');
          location.href = url;
        })
        .finally(() => {
          if (this.request && this.request.signal === signal) this.request = null;
        });
    }
  }

  customElements.define('bb-facets', BBFacets);
})();
